<template>
    <b-modal
            ref="modal"
            centered
            scrollable
            class="text-left"
            @ok="$emit('editScenarios', user, scenarios)"
            size="lg"
    >
        <div slot="modal-title">
            {{this.user.Username}} - Edit scenarios
        </div>
        <div class="table-responsive">
            <table class="table table-sm color mb-2">
                <caption class="caption table-caption">Scenarios available for {{user.Username}}</caption>
                <thead>
                <tr>
                    <th class="text-left text-nowrap">Name</th>
                    <th class="text-left text-nowrap">Vendor</th>
                    <th class="text-left text-nowrap">Deal Name</th>
                    <th class="text-left text-nowrap">Owned By</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(scenario, index) of scenariosSelected" :key="scenario.Id">
                    <td class="text-left text-nowrap">{{scenario.Name}}</td>
                    <td class="text-left text-nowrap">{{scenario.Vendor}}</td>
                    <td class="text-left text-nowrap">{{scenario.DealName}}</td>
                    <td class="text-left text-nowrap">{{scenario.Owner}}</td>
                    <td class="text-right text-nowrap">
                        <b-btn v-if="!scenario.Owned" variant="primary" @click="removeScenario(scenario.Id)">Remove</b-btn>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive">
            <table class="table table-sm color mb-2">
                <caption class="caption table-caption">Remaining scenarios</caption>
                <thead>
                <tr>
                    <th class="text-left text-nowrap">Name</th>
                    <th class="text-left text-nowrap">Vendor</th>
                    <th class="text-left text-nowrap">Deal Name</th>
                    <th class="text-left text-nowrap">Owned By</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(scenario, index) of scenariosAvailable" :key="scenario.Id">
                    <td class="text-left text-nowrap">{{scenario.Name}}</td>
                    <td class="text-left text-nowrap">{{scenario.Vendor}}</td>
                    <td class="text-left text-nowrap">{{scenario.DealName}}</td>
                    <td class="text-left text-nowrap">{{scenario.Owner}}</td>
                    <td class="text-right text-nowrap">
                        <b-btn variant="primary" @click="addScenario(scenario.Id)">Add</b-btn>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<script>
  export default {
    data() {
      return {
        user: {},
        scenarios: []
      };
    },
    computed: {
      scenariosSelected() {
        return this.scenarios.filter(el => Boolean(el.IsAssigned))
      },
      scenariosAvailable() {
        return this.scenarios.filter(el => !Boolean(el.IsAssigned))
      }
    },
    methods: {
      addScenario(Id) {
        this.scenarios.find(el => el.Id === Id).IsAssigned = true;
      },
      removeScenario(Id) {
        this.scenarios.find(el => el.Id === Id).IsAssigned = false;
      },
      showModal(user, scenarios) {
        this.user = user;
        this.scenarios = scenarios;
        this.$refs.modal.show();
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
